/*
 * lotto/calls.js — traditional names of numbers that a host calls out.
 *
 * These are DATA, not interface strings: a tradition exists in a language or
 * it does not, so this is not translated into the other eight locales — they
 * get the plain number, which is what a host there says.
 *
 * RU — «кричалки» of Русское лото. One established name per number, taken
 * where two independent collections agree (ru.wikipedia «Лото», section with
 * barrel names; u-ssr.ru «Советские названия бочонков»). Where a number has no
 * established name, or the only ones are grim or crude, it is left out and the
 * host says the number. Nothing here is invented.
 *
 * EN — the British 90-ball calls (Wikipedia «List of British bingo
 * nicknames»), one per number, choosing the family-friendly classic where the
 * list offers several. Numbers whose only calls are dated or crude are left out.
 */

export const RU = {
    1: 'кол', 2: 'гусь', 3: 'троица', 4: 'стульчик', 5: 'отличник',
    7: 'топорик', 8: 'матрёшка', 9: 'День Победы', 10: 'червонец',
    11: 'барабанные палочки', 12: 'дюжина', 13: 'чёртова дюжина',
    15: 'пятнадцатилетний капитан', 16: 'кругом шестнадцать', 17: 'где мои семнадцать лет',
    18: 'в первый раз', 20: 'лебединое озеро', 21: 'очко', 22: 'гуси-лебеди',
    23: 'два притопа, три прихлопа', 24: 'день в ночь — сутки прочь', 25: 'опять двадцать пять',
    26: 'бакинские комиссары', 28: 'сено косим', 31: 'с Новым годом',
    32: 'три притопа, два прихлопа', 33: 'богатыри', 36: 'нормальная температура',
    38: 'тридцать восемь попугаев', 40: 'Али-Баба', 41: 'ем один', 44: 'стульчики',
    45: 'баба ягодка опять', 48: 'сено косим, половинку просим', 50: 'полтинник',
    55: 'перчатки', 57: 'спутник', 61: 'Гагарин', 63: 'Терешкова', 64: 'шахматы',
    66: 'валенки', 69: 'туда-сюда', 70: 'топор в озере', 75: 'семь пятниц на неделе',
    77: 'топорики', 79: 'золото', 80: 'бабушка', 81: 'бабушка с клюкой',
    82: 'бабушка надвое сказала', 88: 'крендельки', 89: 'дедушкин сосед', 90: 'дедушка',
};

export const EN = {
    1: 'Kelly\'s eye', 2: 'One little duck', 3: 'Cup of tea', 4: 'Knock at the door', 5: 'Man alive',
    6: 'Half a dozen', 7: 'Lucky seven', 8: 'Garden gate', 9: 'Doctor\'s orders', 10: 'Cock and hen',
    11: 'Legs eleven', 12: 'One dozen', 13: 'Unlucky for some', 14: 'Valentine\'s Day', 15: 'Young and keen',
    16: 'Sweet sixteen', 17: 'Dancing queen', 18: 'Coming of age', 19: 'Goodbye, teens', 20: 'One score',
    21: 'Key of the door', 22: 'Two little ducks', 23: 'Thee and me', 24: 'Two dozen', 25: 'Duck and dive',
    26: 'Pick and mix', 27: 'Gateway to heaven', 28: 'In a state', 29: 'Rise and shine', 30: 'Dirty Gertie',
    31: 'Get up and run', 32: 'Buckle my shoe', 33: 'All the threes', 34: 'Ask for more', 35: 'Jump and jive',
    36: 'Three dozen', 37: 'More than eleven', 38: 'Christmas cake', 39: 'All the steps', 40: 'Life begins',
    41: 'Time for fun', 42: 'Winnie the Pooh', 43: 'Down on your knees', 44: 'Droopy drawers', 45: 'Halfway there',
    46: 'Up to tricks', 47: 'Four and seven', 48: 'Four dozen', 49: 'P.C.', 50: 'Half a century',
    51: 'Tweak of the thumb', 52: 'Deck of cards', 53: 'Stuck in the tree', 54: 'Clean the floor', 55: 'Snakes alive',
    57: 'Heinz varieties', 58: 'Make them wait', 59: 'Brighton line', 60: 'Five dozen',
    61: 'Baker\'s bun', 62: 'Tickety-boo', 63: 'Tickle me', 64: 'Red raw', 65: 'Old age pension',
    66: 'Clickety click', 67: 'Stairway to heaven', 68: 'Saving grace', 69: 'Either way up', 70: 'Three score and ten',
    71: 'Bang on the drum', 72: 'Six dozen', 73: 'Queen bee', 74: 'Candy store', 75: 'Strive and strive',
    76: 'Trombones', 77: 'Sunset Strip', 78: 'Heaven\'s gate', 79: 'One more time', 80: 'Eight and blank',
    81: 'Stop and run', 82: 'Straight on through', 83: 'Time for tea', 84: 'Give me more', 85: 'Staying alive',
    86: 'Between the sticks', 87: 'Torquay in Devon', 88: 'Two fat ladies', 89: 'Nearly there', 90: 'Top of the shop',
};

/* Which traditions exist in which interface language. */
const BY_LOCALE = { ru: RU, en: EN };

export function hasTradition(locale) { return !!BY_LOCALE[locale]; }
export function nickname(locale, n) {
    const t = BY_LOCALE[locale];
    return (t && t[n]) || '';
}
